import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";
export const HEADING2 = "HEADING2";
export const HEADING3 = "HEADING3";
export const HEADING4 = "HEADING4";
export const L1 = "L1";
export const L2 = "L2";
export const L3 = "L3";
export const L4 = "L4";
export const L5 = "L5";
export const L6 = "L6";

export const HEADING5 = "HEADING5";

export const A1 = "A1";
export const A2 = "A2";
export const A3 = "A3";
export const A4 = "A4";
export const A5 = "A5";
export const A6 = "A6";
export const A7 = "A7";
export const A8 = "A8";
export const A9 = "A9";

export const translations = {
  en: {
    [HEADING1]: "Financial Performance",
    [HEADING2]: "Financial Position(Rs. in Crores)",
    [HEADING3]: "Particulars",
    [HEADING4]: "Liabilities",
    [L1]: "Capital",
    [L2]: "Reserves",
    [L3]: "Borrowings",
    [L4]: "Trade dues and other current liabilities",
    [L5]: "Profit",
    [L6]: "Total",
    [HEADING5]: "Assets",
    [A1]: "Gross Block",
    [A2]: "Less Depreciation",
    [A3]: "Net Fixed assets",
    [A4]: "Capital work in Progress",
    [A5]: "Investments",
    [A6]: "Current Assets, loans and advances",
    [A7]: "Deferred Revenue Expenditure",
    [A8]: "Loss",
    [A9]: "Total",
  },
  kn: {
    [HEADING1]: "ಹಣಕಾಸಿನ ಕಾರ್ಯನಿರ್ವಹಣೆ",
    [HEADING2]: "ಹಣಕಾಸಿನ ಸ್ಥಿತಿ (ಕೋಟಿಗಳಲ್ಲಿ ರೂ.)",
    [HEADING3]: "ವಿವರಗಳು",
    [HEADING4]: "Liabilities",
    [L1]: "ಬಂಡವಾಳ",
    [L2]: "ಮೀಸಲು",
    [L3]: "ಸಾಲಗಳು",
    [L4]: "ವ್ಯಾಪಾರ ಬಾಕಿಗಳು ಮತ್ತು ಇತರ ಪ್ರಸ್ತುತ",
    [L5]: "ಲಾಭ",
    [L6]: "ಒಟ್ಟು",
    [HEADING5]: "ಸ್ವತ್ತುಗಳು",
    [A1]: "ಒಟ್ಟು ಬ್ಲಾಕ್",
    [A2]: "ಕಡಿಮೆ ಬೆಲೆ ಇಳಿಕೆ",
    [A3]: "ನಿವ್ವಳ ಸ್ಥಿರ ಸ್ವತ್ತುಗಳು",
    [A4]: "ಬಂಡವಾಳದ ಕೆಲಸ ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    [A5]: "ಹೂಡಿಕೆಗಳು",
    [A6]: "ಪ್ರಸ್ತುತ ಸ್ವತ್ತುಗಳು, ಸಾಲಗಳು ಮತ್ತು ಮುಂಗಡಗಳು",
    [A7]: "ಮುಂದೂಡಲ್ಪಟ್ಟ ಆದಾಯ ವೆಚ್ಚ",
    [A8]: "ನಷ್ಟ",
    [A9]: "ಒಟ್ಟು",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
